export default "/assets/images/the-big-sneeze-crop.webp?fd82271b0c18158e4f7952082e33e1dc";